export const API_BASE_URL = 'https://codii.run.place/api';

const getAuthHeader = () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Auth APIs
export const authAPI = {
  register: async (username, email, password) => {
    const response = await fetch(`${API_BASE_URL}/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, email, password }),
    });
    return response.json();
  },

  login: async (email, password) => {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Login failed');
    }
    return response.json();
  },

  getMe: async () => {
    const response = await fetch(`${API_BASE_URL}/auth/me`, {
      headers: getAuthHeader(),
    });
    if (!response.ok) {
      throw new Error('Failed to fetch user');
    }
    return response.json();
  },
};

// Folder APIs
export const folderAPI = {
  getRootFolders: async () => {
    const response = await fetch(`${API_BASE_URL}/folders`, {
      headers: getAuthHeader(),
    });
    if (!response.ok) {
      throw new Error('Failed to fetch folders');
    }
    return response.json();
  },

  getFolder: async (folderId) => {
    const response = await fetch(`${API_BASE_URL}/folders/${folderId}`, {
      headers: getAuthHeader(),
    });
    if (!response.ok) {
      throw new Error('Failed to fetch folder');
    }
    return response.json();
  },

  createRootFolder: async (name) => {
    const response = await fetch(`${API_BASE_URL}/folders`, {
      method: 'POST',
      headers: {
        ...getAuthHeader(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name }),
    });
    if (!response.ok) {
      throw new Error('Failed to create folder');
    }
    return response.json();
  },

  createSubfolder: async (parentId, name) => {
    const response = await fetch(`${API_BASE_URL}/folders/${parentId}/subfolder`, {
      method: 'POST',
      headers: {
        ...getAuthHeader(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name }),
    });
    if (!response.ok) {
      throw new Error('Failed to create subfolder');
    }
    return response.json();
  },

  deleteFolder: async (folderId) => {
    const response = await fetch(`${API_BASE_URL}/folders/${folderId}`, {
      method: 'DELETE',
      headers: getAuthHeader(),
    });
    if (!response.ok) {
      throw new Error('Failed to delete folder');
    }
    return response.json();
  },
};

// File APIs
export const fileAPI = {
  getFile: async (fileId) => {
    const response = await fetch(`${API_BASE_URL}/files/${fileId}`, {
      headers: getAuthHeader(),
    });
    if (!response.ok) {
      throw new Error('Failed to fetch file');
    }
    return response.json();
  },

  createFile: async (name, extension, content, folderId) => {
    const response = await fetch(`${API_BASE_URL}/files`, {
      method: 'POST',
      headers: {
        ...getAuthHeader(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name, extension, content, folder_id: folderId }),
    });
    if (!response.ok) {
      throw new Error('Failed to create file');
    }
    return response.json();
  },

  updateFile: async (fileId, content) => {
    const response = await fetch(`${API_BASE_URL}/files/${fileId}`, {
      method: 'PUT',
      headers: {
        ...getAuthHeader(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ content }),
    });
    if (!response.ok) {
      throw new Error('Failed to update file');
    }
    return response.json();
  },

  deleteFile: async (fileId) => {
    const response = await fetch(`${API_BASE_URL}/files/${fileId}`, {
      method: 'DELETE',
      headers: getAuthHeader(),
    });
    if (!response.ok) {
      throw new Error('Failed to delete file');
    }
    return response.json();
  },
};

// Share APIs
export const shareAPI = {
  createShareLink: async (fileId) => {
    const response = await fetch(`${API_BASE_URL}/files/${fileId}/share`, {
      method: 'POST',
      headers: getAuthHeader(),
    });
    if (!response.ok) {
      throw new Error('Failed to create share link');
    }
    return response.json();
  },

  getSharedFile: async (token) => {
    const response = await fetch(`${API_BASE_URL}/share/${token}`);
    if (!response.ok) {
      throw new Error('Failed to fetch shared file');
    }
    return response.json();
  },
};
